module.exports = __webpack_public_path__ + "img/cartes_bancaires_2024_10_23.e3fc8e2.svg";